import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Most powerful git tool vimmer ever created...`}</p>
    <h1>{`Why`}</h1>
    <p>{`This is just a simple tutorial to features I found useful in `}<a parentName="p" {...{
        "href": "https://github.com/tpope/vim-fugitive"
      }}>{`Fugitive.vim`}</a>{`.`}</p>
    <p>{`In my experience, Fugitive is like a surgery tool directly operating on those SHA objects in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.git`}</code>{`. There's basically nothing it cannot do and it sounds so illegal. However, it's not foolproof type of product, instead, you need to dive deeper into its documents and tutorial to find your own way. So this blog is just to summarize my way. But I hope it's also useful for you.`}</p>
    <h1>{`Basic Concept`}</h1>
    <p>{`First, you need to understand what's `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fugitive object`}</code>{`. We have 3 types of object: `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`tree`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`blob`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`commit`}</code>{`. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`tree`}</code>{` is folder structure; `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`blob`}</code>{` is file; and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`commit`}</code>{` is the commit object. All of them are coded in SHA to refer to. `}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/tpope/vim-fugitive/blob/master/doc/fugitive.txt#L593-L615"
      }}>{`Here`}</a>{`'s the example for how Fugitive refers to these objects. But it's much more than you could use in daily life though! What I found useful are:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`**HEAD~2** HEAD's previous 2 commit object and @ equals HEAD if you like to type short
**master~2** master current commit's previous 2 commit object
**branch:filename** e.g. master:% current file blob, or just give branch name master for current file
**branch:** branch tree object
**@~2:filename** HEAD's grandparent's file blob`}</code></pre></div>
    <p>{`In following, I'll just call them object with this context. Together with normal git version syntax, it's easy enough to identify files of different branch and commits. Let's see how powerful it is.`}</p>
    <h1>{`Fugitive Swiss Knife`}</h1>
    <h2>{`Git`}</h2>
    <p>{`Type `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:G`}</code>{` and you get interactive `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`git status`}</code>{`, where you could staged/unstaged (-), revert (X), and check diff (dv). Do you still remember the painful `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`git add -p`}</code>{` command? When you diff you can directly edit the staged version to partially stage your changes!`}</p>
    <p>{`This single interface alone is very satisfying already and probably cover 60% of your git usage. `}</p>
    <h2>{`Git diff(tool)`}</h2>
    <p>{`You can directly diff two version e.g. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:G d object1 object2`}</code>{` (diff object now has issue). It returns you the list of diff files. Use `}<kbd>{`[q`}</kbd>{` and `}<kbd>{`]`}{`q`}</kbd>{` to move between hotspot. To view file line by line diff, you can add this `}<a parentName="p" {...{
        "href": "https://github.com/tpope/vim-fugitive/issues/132#issuecomment-570844756"
      }}>{`temporary fix`}</a>{`. I personally bind it to a `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/commit/db62f1d86b2d1a92584e61d9bcce1ab3cde0c32b#diff-35c46ca8a60cfeffe2fb3abb0865cbd7b0caa446d207e0b0d8b4d523221438e4R248"
      }}>{`key`}</a>{` so that we could diff lines anytime.`}</p>
    <h2>{`Git log (Following Files)`}</h2>
    <p>{`You can trace historical changes through `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:0Gclog -- %`}</code>{` to get all commits containing current file. Of course `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`%`}</code>{` is just vim's syntax sugar for current file. You can put any file after the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`--`}</code>{`. To diff any 2 versions in the quickfix window, I open a version (in current buffer) and use `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/commit/162431234f74b607415f569aa541672d40c76940#diff-35c46ca8a60cfeffe2fb3abb0865cbd7b0caa446d207e0b0d8b4d523221438e4R246"
      }}>{`key`}</a>{` to select another version to diff against current buffer.`}</p>
    <h2>{`Git mergetool`}</h2>
    <p>{`You can directly merge the conflicting file using `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Gvdiffsplit!`}</code>{`. Conflicting file will open as three way merge style. 3-way merge windows looks confusing but it's actually straightforward: From left to right is `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Merge Target`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Ours`}</code>{` ➡ `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Working Copy`}</code>{` ➡ `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Feature Branch`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Theirs`}</code>{`.`}</p>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`:diffget`}</code>{` is the same as normal vimdiff mode except that you need to give buffer name. For example, for buffers like:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`Ours: ......//2/demo.js
Working: ....../demo.js
Theirs: ......//3/demo.js`}</code></pre></div>
    <p>{`Then you 3-way merge will refer to these buffer with the name `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`2`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`demo`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`3`}</code>{`. For example, to get from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Ours`}</code>{`, we type `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:diffget 2`}</code>{`. To conclude your merge, just `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:Gwrite`}</code>{`.`}</p>
    <h2>{`Gedit`}</h2>
    <p>{`You can get any version in git like God using `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:Gedit object`}</code>{`. For example, if I want to see the file in a feature branch, I just do `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:Gedit branchname:/path/to/file`}</code>{`. Or if not sure about the filename, I'll just `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:Gedit branchname:`}</code>{` to open tree object or folder.`}</p>
    <p>{`Run `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:Gedit`}</code>{` without any parameters will take you back to working copy. Combining with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Gvdiffsplit`}</code>{` you can diff with any version as well manually.`}</p>
    <h2>{`Gwrite`}</h2>
    <p>{`Write/save your working one and also update to staged. It's somewhat useful when you do merging and want to use purely from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Ours`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Theirs`}</code>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      